jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;

    whenGsapReady(() => {
      whenScrollReady(() => {
        initTechnologyOverviewReveal();
      });
    });

    initTechnologyOverviewSlider();
  });

  function initTechnologyOverviewReveal() {
    const blocks = document.querySelectorAll(".js-to");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.toRevealInit === "1") return;
      block.dataset.toRevealInit = "1";

      const items = block.querySelectorAll(".js-to-item");
      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 18 });

      const vars = {
        autoAlpha: 1,
        y: 0,
        duration: 0.95,
        ease: "power3.out",
        stagger: 0.1,
        clearProps: "transform",
      };

      if (ScrollTrigger) {
        vars.scrollTrigger = {
          trigger: block,
          start: "top 75%",
          once: true,
          invalidateOnRefresh: true,
        };
      }

      gsap.to(items, vars);
    });
  }

  function initTechnologyOverviewSlider() {
    const blocks = document.querySelectorAll(".js-to");
    if (!blocks.length) return;

    blocks.forEach((block) => {
      if (block.dataset.toSliderInit === "1") return;
      block.dataset.toSliderInit = "1";

      const track = block.querySelector(".js-to-track");
      const prev = block.querySelector(".js-to-prev");
      const next = block.querySelector(".js-to-next");
      if (!track || !prev || !next) return;

      const slides = Array.from(track.children);
      if (slides.length <= 1) return;

      let index = 0;

      const visibleCount = () => (window.innerWidth <= 980 ? 1 : 2);

      const getMaxIndex = () => Math.max(0, slides.length - visibleCount());

      const update = () => {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(track).gap || "0");
        const offset = (slideWidth + gap) * index;
        track.style.transform = `translate3d(${-offset}px,0,0)`;

        prev.disabled = index <= 0;
        next.disabled = index >= getMaxIndex();
      };

      prev.addEventListener("click", () => {
        index = Math.max(0, index - 1);
        update();
      });

      next.addEventListener("click", () => {
        index = Math.min(getMaxIndex(), index + 1);
        update();
      });

      window.addEventListener("resize", () => {
        index = Math.min(index, getMaxIndex());
        update();
      });

      update();
    });
  }
});
